import { useInstallAppState } from '../../utils/useInstallAppState';
import { InstallAppContext } from './pwaContext';
import { InstallSheet } from './InstallSheet';

/**
 * The installed app's doors for the whole site, above the router so nothing starts over between the public pages and
 * the app: one state, and the one steps sheet the banner, the footer badge and Conta all open.
 */
export const InstallAppProvider = ({ children }) => {
  const { state, sheet } = useInstallAppState();
  return (
    <InstallAppContext.Provider value={state}>
      {children}
      <InstallSheet {...sheet} />
    </InstallAppContext.Provider>
  );
};
